import { ErrorMessage } from '../../../../common/ErrorMessageUtil';
import { LoadingState } from '../../../Campaign/types';

export const SLICE_NAME = 'influencerSignin';

export interface InfluencerSigninState {
  loadingState: LoadingState;
  error: ErrorMessage[] | null;
}
